import { OfflineStorage } from "./estrylib";

export const TravelInsuranceType = "Travel";
export const HealthInsuranceType = "Health";
export const KaskoInsuranceType = "Kasko";
export const TrafficInsuranceType = "Traffic";
export const DaskInsuranceType = "Dask";
export const TourismInsuranceType = "Tourism";
export const TssInsuranceType = "Tss";
export const OssInsuranceType = "Oss";

export const InsuranceTypes = [
  {
    label: window.sys_app_translate(
      TravelInsuranceType,
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: TravelInsuranceType,
  },
  {
    label: window.sys_app_translate(
      HealthInsuranceType,
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: HealthInsuranceType,
  },
  {
    label: window.sys_app_translate(
      KaskoInsuranceType,
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: KaskoInsuranceType,
  },
  {
    label: window.sys_app_translate(
      TrafficInsuranceType,
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: TrafficInsuranceType,
  },
  {
    label: window.sys_app_translate(
      DaskInsuranceType,
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: DaskInsuranceType,
  },
  {
    label: window.sys_app_translate(
      TourismInsuranceType,
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: TourismInsuranceType,
  },
  {
    label: window.sys_app_translate(
      TssInsuranceType,
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: TssInsuranceType,
  },
  {
    label: window.sys_app_translate(
      OssInsuranceType,
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: OssInsuranceType,
  },
];
